import React from 'react';
import BaseVegetableCharacter from './BaseVegetableCharacter';

const GarlicCharacter = (props) => {
    const primaryColor = "#f5f5f5"; // White
    const secondaryColor = "#e0e0e0"; // Slightly off-white

    const renderGarlicBody = () => (
        <>
            {/* Garlic Body - slightly elongated bulb */}
            <mesh castShadow>
                <sphereGeometry args={[0.25, 16, 16]} />
                <meshStandardMaterial color={primaryColor} />
            </mesh>

            {/* Garlic clove segments */}
            {[...Array(7)].map((_, i) => {
                const angle = (i / 7) * Math.PI * 2;
                const x = Math.sin(angle) * 0.2;
                const z = Math.cos(angle) * 0.2;
                return (
                    <mesh key={i} position={[x, 0, z]} castShadow>
                        <sphereGeometry args={[0.15, 8, 8]} />
                        <meshStandardMaterial color={primaryColor} />
                    </mesh>
                );
            })}

            {/* Garlic tip/stem */}
            <mesh castShadow position={[0, 0.35, 0]}>
                <coneGeometry args={[0.05, 0.2, 8]} />
                <meshStandardMaterial color="#c5e1a5" />
            </mesh>

            {/* Dry skin texture lines */}
            {[...Array(5)].map((_, i) => {
                return (
                    <mesh key={i} position={[0, -0.1 + i * 0.1, 0]} castShadow>
                        <torusGeometry args={[0.25, 0.01, 4, 24]} />
                        <meshStandardMaterial color="#eeeeee" />
                    </mesh>
                );
            })}
        </>
    );

    return (
        <BaseVegetableCharacter
            {...props}
            renderBody={renderGarlicBody}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
        />
    );
};

export default GarlicCharacter;
